module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sentry-reporting":"Report errors via Sentry.io third party service"},"de":{"Behavior":"Verhalten","Development":"Entwicklung","CouchDB instance for saving":"CouchDB-Instanz zum Speichern","Save geolocation of each shopped item":"Standort jedes Einkaufs speichern (GPS)","sentry-reporting":"Fehler über den externen Dienst Sentry.io melden"}}')
  delete Component.options._Ctor
}
